import { render, staticRenderFns } from "./SendMessageOtherUserDetailTab.vue?vue&type=template&id=8d9d21f8&scoped=true&lang=pug"
import script from "./SendMessageOtherUserDetailTab.vue?vue&type=script&lang=ts"
export * from "./SendMessageOtherUserDetailTab.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageOtherUserDetailTab.vue?vue&type=style&index=0&id=8d9d21f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9d21f8",
  null
  
)

export default component.exports